import { ListItem } from '@/components';
import { formatToSentenceCase } from '@/utils/formatUtils';
import Image from 'next/image';
import { FC, memo } from 'react';
export interface NetworkListItemProps {
  blockchain: string;
  blockchainDisplayName?: string;
  align?: 'left' | 'center' | 'right';
  showIcon?: boolean;
}
const NetworkListItem: FC<NetworkListItemProps> = memo(
  ({ blockchain, blockchainDisplayName, align = 'left', showIcon = true }) => {
    const displayName =
      blockchainDisplayName || formatToSentenceCase(blockchain);
    return (
      <ListItem
        mainText={displayName}
        leftIcon={
          showIcon && (
            <Image
              src={`/images/crypto-logos/svg/color/chain-${blockchain.toLowerCase()}.svg`}
              alt={displayName}
              width={32}
              height={32}
              loading="lazy"
              unoptimized
            />
          )
        }
        align={align}
      />
    );
  },
);
export default NetworkListItem;
